module.exports = __webpack_public_path__ + "static/media/dream_compass9e0c85ab33386482f1bbf273eb8eb901.webp";